import { UiService } from './ui.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Subject, Observable, Subscription, BehaviorSubject } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { Site } from '@classes/site';

import * as FileSaver from 'file-saver';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import * as moment from 'moment';
import { Pagination } from '@classes/pagination/pagination';

@Injectable({
  providedIn: 'root'
})
export class TimeRecordsService {
    sitesListChanged = new Subject<Site[]>();
    history: any[] = [];
    historyListChanged = new Subject<any[]>();
    paginationSubject = new BehaviorSubject<Pagination>(null);


    private baseUrl: string = environment.apiUrl + 'time-records';

    private lastQueryObj: {};
    private getListSub: Subscription;

    constructor(
        private http: HttpClient,
        private uiSrv: UiService
    ) { }

    exportExcel(userId: string, year: string, month: string): Observable<Blob> {
      this.uiSrv.loadingStateChanged.next(true);
      return this.http.get(`${this.baseUrl}/xlsx?userId=${userId}&year=${year}&month=${month}`, { observe: 'response', responseType: 'blob' })
        .pipe(map(res => this.saveFile(res)));
    }

    private saveFile(res: HttpResponse<Blob>): Blob {
      FileSaver.saveAs(res.body, res.headers.get('filename'));
      this.uiSrv.loadingStateChanged.next(false);
      return res.body;
    }

    getHistory(request: PaginationRequest,): void {
      if (this.getListSub) {
        this.getListSub.unsubscribe();
      }

      let httpParams = new HttpParams();
      if (request.pageSize && request.page) {
        httpParams = httpParams
          .append("pageSize", request.pageSize.toString())
          // .append("page", request.query !== this.lastQuery ? "1" : request.page.toString());
          .append("page", request.query !== this.lastQueryObj ? "1" : request.page.toString());
      }

      if (request.query) {

        const filters = request.query;
        const filtersQuery = [];


        if (filters.user) {
          filtersQuery.push(`userId==${filters.user}`);
        }
        if (filters.comment) {
          filtersQuery.push(`comment@=${filters.comment}`);
        }

        if (filters.type) {
          if (filters.type !== 'all') {
            filtersQuery.push(`type==${filters.type}`);
          }
        }

        if (filters.date) {
          filtersQuery.push(`date>=${moment(filters.date).startOf('day').utc().format().toString()}`);
          filtersQuery.push(`date<=${moment(filters.date).endOf('day').utc().format().toString()}`);
        }

        if (filters.createdOn) {
          filtersQuery.push(`createdOn>=${moment(filters.createdOn).startOf('day').utc().format().toString()}`);
          filtersQuery.push(`createdOn<=${moment(filters.createdOn).endOf('day').utc().format().toString()}`);
        }

        httpParams = httpParams.append("Filters", filtersQuery.join());
      }

      if (request.sort) {
        if (request.sort !== '-startDate') {
          if (request.sort === 'user') {
            request.sort = 'userId';
          } else if (request.sort === '-user') {
            request.sort = '-userId';
          }
          httpParams = httpParams.append("sorts", request.sort);
        }

      }

      this.lastQueryObj = request.query;

      this.getListSub = this.http.get(`${this.baseUrl}/history`, { params: httpParams, observe: 'response' })
      .subscribe((result: HttpResponse<any[]>) => {
        this.uiSrv.loadingStateChanged.next(false);
        const pagination: Pagination = JSON.parse(result.headers.get('X-Pagination'));

        this.history = result.body;
        this.historyListChanged.next([ ...this.history ]);
        this.paginationSubject.next({ ...pagination });
      });
  }
}
